import {Injectable} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import * as moment from 'moment/moment';
import * as environment from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationsHelperService {
  private  readonly monthShortcuts = ['Jan','Feb', 'Mar', 'Apr', 'May ', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor(private _translocoService: TranslocoService) { }

    changeLanguage(langShortcut: string):string{
        const languageToSet = environment.environment.locale.availableLanguages.indexOf(langShortcut) > 0 ? langShortcut : environment.environment.locale.defaultLanguage;
        this._translocoService.setActiveLang(  languageToSet);
        return languageToSet;
    }

    translateMonthByIndex(month: number, returnShortcut: boolean = false): string {
        if (month > 11 || month < 0) {
            throw new Error(`${month} is not a month (Out of range)`);
        }
        return returnShortcut ? moment.monthsShort()[month] : moment.months()[month];
    }

    matchMonthByShortcut(month: string):number {
        return this.monthShortcuts.findIndex(shortcut => shortcut?.trim().toLowerCase() === month?.trim().toLowerCase());
    }
}
